module.exports = __webpack_public_path__ + "img/app-store.782bda65.png";